import { render, staticRenderFns } from "./_klon.vue?vue&type=template&id=0288776c&"
import script from "./_klon.vue?vue&type=script&lang=js&"
export * from "./_klon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports